<section class="fl-command-palette" role="search">
  <div class="fl-command-palette__header">
    <div class="fl-command-palette__title">
      <span class="fl-command-palette__title-icon">
        <mat-icon aria-hidden="true">travel_explore</mat-icon>
      </span>
      <div>
        <h2>Search workspace</h2>
        <p>Find pages, workflows, reports, and settings.</p>
      </div>
    </div>
    <button mat-icon-button type="button" aria-label="Close search" (click)="close()">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>

  <div class="fl-command-palette__searchbox">
    <mat-icon aria-hidden="true">search</mat-icon>
    <input
      #searchInput
      type="search"
      [value]="query"
      (input)="onInput($event)"
      (keydown)="onKeydown($event)"
      [attr.aria-activedescendant]="activeCommandId"
      aria-controls="forlab-command-palette-results"
      aria-label="Search pages and actions"
      placeholder="Type a page, module, or workflow" />
    <span class="fl-command-palette__key">Esc</span>
  </div>

  <div class="fl-command-palette__body">
    <div
      *ngIf="results.length; else emptyState"
      id="forlab-command-palette-results"
      class="fl-command-palette__results"
      role="listbox"
      aria-label="Matching pages and commands">
      <button
        [id]="optionId(command)"
        class="fl-command-palette__result"
        type="button"
        role="option"
        *ngFor="let command of results; let i = index; trackBy: trackCommand"
        [class.fl-command-palette__result--active]="i === activeIndex"
        [attr.aria-selected]="i === activeIndex"
        (mouseenter)="setActive(i)"
        (click)="select(command)">
        <span class="fl-command-palette__result-icon">
          <mat-icon aria-hidden="true">{{ iconFor(command) }}</mat-icon>
        </span>
        <span class="fl-command-palette__result-copy">
          <strong>{{ command.label }}</strong>
          <small>{{ command.group }} · {{ command.route }}</small>
        </span>
        <mat-icon class="fl-command-palette__result-arrow" aria-hidden="true">arrow_forward</mat-icon>
      </button>
    </div>

    <ng-template #emptyState>
      <div class="fl-command-palette__empty">
        <mat-icon aria-hidden="true">search_off</mat-icon>
        <h3>No matching action found</h3>
        <p>Try a page name, workflow, report, or feature keyword.</p>
      </div>
    </ng-template>
  </div>

  <footer class="fl-command-palette__footer">
    <span><strong>↑ ↓</strong> move</span>
    <span><strong>Enter</strong> open</span>
    <span><strong>Esc</strong> close</span>
  </footer>
</section>
